import { primaryColor, primaryBoxShadow, defaultFont } from 'assets/styles/jss/main';

export default {
  container: {
    position: 'relative',
  },
  dropdown: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '65px',
    borderRadius: '3px',
    border: '0',
    boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.26)',
    zIndex: '1000',
    minWidth: '160px',
    maxHeight: '240px',
    overflow: 'hidden',
    overflowY: 'scroll',
    padding: '5px 0',
    margin: '2px 0 0',
    fontSize: '16px',
    textAlign: 'left',
    listStyle: 'none',
    backgroundColor: '#fff',
    backgroundClip: 'padding-box',
  },
  dropdownItem: {
    ...defaultFont,
    fontSize: '13px',
    padding: '10px 20px',
    margin: '0 5px',
    borderRadius: '2px',
    position: 'relative',
    transition: 'all 150ms linear',
    display: 'block',
    clear: 'both',
    fontWeight: '400',
    height: 'fit-content',
    color: '#333',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: primaryColor,
      color: '#FFFFFF',
      ...primaryBoxShadow,
    },
  },
  menuList: {
    padding: '0',
  },
};
